import { CoreIcon } from '../core-icon';
import uploadFillSVG from '../../assets/icons/upload-fill.svg';
import type { IconProps } from '../core-icon';

export const UploadFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={uploadFillSVG} {...props} />;
};
